const waypoints = require('waypoints/lib/noframework.waypoints.min.js');
const inView = require('in-view'); // https://github.com/camwiegert/in-view

document.addEventListener('DOMContentLoaded', () => {

  if (document.body.classList.contains('block-editor-page')) {
    return;
  }

  const animationElements = document.querySelectorAll('.animate-on-scroll');

  animationElements.forEach((element) => {
    setTimeout(() => {
      inView('.animate-on-scroll').on('enter', (element) => {
        if (element.classList.contains('card-grid__elements')) {
          element.querySelectorAll('.card-grid__element').forEach((card, index) => {
            card.style.animationDelay = `${index * 0.2}s`;
          });
        }
        element.classList.add('animate-on-scroll--active');
      });
      inView('.animate-on-scroll').check();
    }, 250);
  });
});
